module.exports = __webpack_public_path__ + "scale.17c9a472.png";